"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 18px;\n  display: inline-block;\n\n  > input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  > .pui-switch__toggle {\n    background-color: rgb(206,206,206);\n    width: 100%;\n    height: 10px;\n    display: block;\n    border-radius: 6px;\n    cursor: pointer;\n    margin-top: -18px;\n  }\n\n  > .pui-switch__toggle:after {\n    content: \"\";\n    background-color: rgb(157,157,157);\n    width: 18px;\n    height: 18px;\n    display: block;\n    position: absolute;\n    border-radius: 50%;\n    transition: 0.4s;\n    margin-top: -4px;\n  }\n\n  > input:checked + .pui-switch__toggle:after {\n    transform: translateX(12px);\n  }\n\n  > input:disabled + .pui-switch__toggle {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  &.pui-switch--color-primary {\n    > input:checked + .pui-switch__toggle {\n      background-color: rgb(128,194,246);\n    }\n\n    > input:checked + .pui-switch__toggle:after {\n      background-color: rgb(0,132,238);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSwitch = _styledComponents["default"].label(_templateObject());

exports.StyledSwitch = StyledSwitch;

var Switch = function Switch(_ref) {
  var className = _ref.className,
      color = _ref.color,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      onToggle = _ref.onToggle,
      props = _objectWithoutProperties(_ref, ["className", "color", "checked", "disabled", "onChange", "onToggle"]);

  var handleChange = function handleChange(e) {
    if (onChange) onChange(e);
    if (checked !== e.target.checked && onToggle) onToggle(e.target.checked);
  };

  return /*#__PURE__*/_react["default"].createElement(StyledSwitch, _extends({}, props, {
    className: (0, _clsx["default"])(className, "pui-switch--color-".concat(color), {
      'pui-switch--checked': checked,
      'pui-switch--disabled': disabled
    })
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    disabled: Boolean(disabled),
    checked: Boolean(checked),
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pui-switch__toggle"
  }));
};

Switch.defaultProps = {
  disabled: false,
  checked: false,
  color: 'primary',
  onChange: function onChange() {}
};
var _default = Switch;
exports["default"] = _default;